import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";

function NoRouteFound() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#ecf1f9",
      }}
      component="main"
    >
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: "1.5rem" }}>404 Page Not Found</Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{
            padding: "5px 10px",
            fontSize: "1rem",
            mt: 4,
          }}
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
}
export default NoRouteFound;
